import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usePopup } from '../context/PopupContext';
import TopBar from './TopBar';

export default function LpHeader() {
  const { openPopup } = usePopup();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <TopBar />
      <header
        data-testid="lp-header"
        className={`fixed w-full z-50 transition-all duration-300 ${
          scrolled ? 'top-0 bg-[#0A1128]/95' : 'top-[35px] bg-[#0A1128]/90'
        } backdrop-blur-xl border-b border-white/5`}
      >
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <img src="/assets/img/brand/logo-light.png" alt="Trademark Legal Forum" className="h-8 sm:h-12 w-auto" />
       
        <div className="flex items-center gap-3">
          <button
            data-testid="lp-header-register-btn"
            onClick={() => openPopup()}
            className="hidden sm:block bg-[#D4AF37] text-[#0A1128] font-bold py-2.5 px-5 sm:px-6 rounded-sm text-xs sm:text-sm transition-all duration-300 hover:bg-[#F3E5AB] hover:-translate-y-0.5 shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] font-['Outfit'] tracking-wide"
          >
            Register My Trademark
          </button>
          <button
            data-testid="lp-header-chat-btn"
            className="js-chat border border-[#D4AF37]/50 text-[#D4AF37] font-bold py-2.5 px-5 sm:px-6 rounded-sm text-xs sm:text-sm transition-all duration-300 hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] font-['Outfit'] tracking-wide"
          >
            Chat Now
          </button>
        </div>
      </div>
    </header>
    </>
  );
}
